import errorHandlers from '@/services/error-handlers';
import events from '@/services/events';
import http from '@/services/http';



export default {
  namespaced: true,

  state: {
    areLoading: false,
    deletingOrderId: null,
    isSelectingOrder: false,
    orders: [],
    upsertingOrderId: null
  },

  getters: {
    favoriteOrders(state) {
      return state;
    }
  },

  actions: {
    async deleteFavoriteOrder({ commit, state }, orderId) {
      try {
        commit('SET_DELETE_LOADING_STATUS', orderId);

        await http.delete(`/cardfree-api/v1/account/me/order/${orderId}/favorite`);

        const orders = state.orders.filter(order => orderId !== order.orderId);

        commit('SET_FAVORITE_ORDERS', orders);

        events.emit('notification', {
          type: 'success',
          message: 'Favorite order was deleted.'
        });
      }

      catch (error) {
        errorHandlers.generic(error);
      }

      finally {
        commit('SET_DELETE_LOADING_STATUS', null);
      }
    },

    async getFavoriteOrders({ commit }) {
      try {
        commit('SET_LOADING_STATUS', true);

        const response = await http.get('/cardfree-api/v1/account/me/order/favorite');

        commit('SET_FAVORITE_ORDERS', response.data.data);
      }

      catch (error) {
        errorHandlers.generic(error);
      }

      finally {
        commit('SET_LOADING_STATUS', false);
      }
    },

    async upsertFavoriteOrder({ commit, dispatch }, options) {
      commit('SET_UPSERT_LOADING_STATUS', options.orderId);

      try {
        await http.put(`/cardfree-api/v1/account/me/order/${options.orderId}/favorite`, {
          nickname: options.nickname
        });

        if (options.refresh) {
          await dispatch('getFavoriteOrders');
        }

        events.emit('notification', {
          type: 'success',
          message: 'Favorite order was saved.'
        });
      }

      catch (error) {
        throw error;
      }

      finally {
        commit('SET_UPSERT_LOADING_STATUS', null);
      }
    }
  },

  mutations: {
    SET_DELETE_LOADING_STATUS(state, id) {
      state.deletingOrderId = id;
    },

    SET_FAVORITE_ORDERS(state, orders) {
      state.orders = orders || [];
    },

    SET_LOADING_STATUS(state, areLoading) {
      state.areLoading = areLoading;
    },

    SET_SELECT_LOADING_STATUS(state, isSelecting) {
      state.isSelectingOrder = isSelecting;
    },

    SET_UPSERT_LOADING_STATUS(state, id) {
      state.upsertingOrderId = id;
    }
  }
};
